//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploader } from '@/utils/uploadCloud';
import { fileLinkDownLoad, formatBytes, getFileType, isTypeImage } from '@/libs/public';
import imageViewer from '@/components/common/imageViewer';
import helper from '@/libs/helper';
export default {
  name: 'UploadFileList',
  components: {
    imageViewer: imageViewer
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    fileSize: {
      type: Number,
      default: helper.fileSize
    },
    onlyImage: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'post'
    },
    url: {
      type: String,
      default: '',
      required: true
    },
    params: {
      type: Object,
      default: function _default() {}
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showClose: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 9
    },
    // 最多上传文件数量
    fileWidth: {
      type: String,
      default: '426px'
    }
  },
  data: function data() {
    return {
      percentShow: false,
      percent: 0,
      fileName: '',
      srcList: []
    };
  },
  watch: {
    fileList: {
      handler: function handler(nVal) {
        var _this = this;
        this.srcList = [];
        if (nVal.length > 0) {
          nVal.forEach(function (value) {
            if (isTypeImage(value.name || value.real_name)) {
              _this.srcList.push(value.file_url || value.att_dir);
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    uploadServerLog: function uploadServerLog(params) {
      var _this2 = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: this.params.way ? this.params.way : 2,
        relation_type: this.params.relation_type,
        relation_id: 0,
        eid: this.params.eid
      };
      var onlyImg = this.onlyImage ? 1 : 0;
      uploader(file, onlyImg, 15, options).then(function (res) {
        if (res.name) {
          _this2.$emit('on-success', res, _this2.onlyImage);
          _this2.percentShow = false;
        }
      }).catch(function (err) {
        _this2.percentShow = false;
      });
    },
    toSrcIcon: function toSrcIcon(name) {
      return getFileType(name);
    },
    toSizeFile: function toSizeFile(size) {
      return formatBytes(size);
    },
    fileDelete: function fileDelete(index) {
      this.fileList.splice(index, 1);
    },
    lookViewer: function lookViewer(item) {
      var url = item.file_url || item.url || item.src || item.att_dir;
      var name = item.name ? item.name : item.real_name;
      if (isTypeImage(url)) {
        this.$refs.imageViewer.openImageViewer(url);
      } else {
        fileLinkDownLoad(url, name);
      }
    }
  }
};